import {
  Outlet,
  createRootRouteWithContext,
  useRouter,
} from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider as AriaRouterProvider } from 'react-aria-components';
import { Toaster } from 'sonner';
import { RouteIndicatorProvider } from '@maia/utils';
import { ErrorPage } from '@maia/ui';
import { MaintenanceNotice } from '../features/misc/MaintenanceNotice';

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Component,
  notFoundComponent: () => (
    <ErrorPage
      title="Pagina niet gevonden"
      description="Oops, deze pagina kunnen wij niet meer vinden of bestaat niet meer"
      action={{ type: 'link', to: '/dashboard', title: 'Terug naar dashboard' }}
    />
  ),
  errorComponent: () => (
    <ErrorPage
      title="Er ging iets mis"
      description="Er ging iets mis dat we niet hadden voorzien. Onze developers kijken wat er aan de hand is."
      action={{ type: 'link', to: '/', title: 'Terug naar inlog' }}
    />
  ),
});

export function Component() {
  const router = useRouter();

  if (import.meta.env.VITE_MAINTENANCE_MODE === 'true') {
    return <MaintenanceNotice />;
  }

  return (
    <AriaRouterProvider
      navigate={(to, options) => router.navigate({ to, ...options })}
      useHref={(to) => router.buildLocation({ to }).href}
    >
      <RouteIndicatorProvider>
        <Outlet />
        <div id="document-portal" />
      </RouteIndicatorProvider>
      {import.meta.env.MODE === 'development' && (
        <>
          <TanStackRouterDevtools />
          <ReactQueryDevtools />
        </>
      )}
      <Toaster />
    </AriaRouterProvider>
  );
}
